import React from "react"
import { ReportAPI } from "../../../lib/utils"
import ReportForm from "../ReportForm"

export default function BatchPerformanceReport() {
  return <ReportForm reportAPI={ ReportAPI.BATCH_PERFORMANCE } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/financiers/BatchPerformance.js